import React, { memo, useState } from 'react';
import { IconRatingStar, IconLoading, Tooltip } from 'gatorcomponents';
import * as Styles from './FavoriteButton.styles';
import { useDispatch } from 'react-redux';
import { advancedHostingActions } from '@/redux/modules/advancedHosting';

const FavoriteButton = memo(({
  serverId,
  isFavorite,
  locale,
  onSuccess,
  size = 'sm2',
}) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const handleUpdateFavoriteStatus = () => {
    setIsLoading(true);
    dispatch(advancedHostingActions.updateServer.request({
      serverId,
      isFavorite: !isFavorite,
      onSuccess: (data) => {
        setIsLoading(false);
        if (onSuccess) onSuccess(data);
      },
    }));
  };

  return (
    <Tooltip content={locale?.favorite} preferredPosition="bottomRight">
      <Styles.Favorite
        onClick={!isLoading ? handleUpdateFavoriteStatus : undefined}
        data-testid={`favorite-button-${serverId}`}
        aria-label={locale?.favorite}
        $isFavorite={isFavorite}
      >
        {isLoading ? (
          <IconLoading size={size} />
        ) : (
          <IconRatingStar
            size={size}
            color={isFavorite ? 'attentionMedium' : 'lowMedium'}
            filled={isFavorite}
          />
        )}
      </Styles.Favorite>
    </Tooltip>
  );
});

FavoriteButton.displayName = 'FavoriteButton';
export default FavoriteButton;
